import { Search, SearchOutlined, ShoppingCartOutlined } from '@mui/icons-material';
import { Badge } from '@mui/material';
import React from 'react';
import styled from 'styled-components';
import {mobile} from "../responsive";
import {Register} from "../pages/Register";

const Container = styled.div`

height: 60px;
background-color: #ffe5cc;
${mobile({height: "50px"})}
}`;

const Wrapper = styled.div`
padding: 10px 30px 10px 10px;
display: flex;
justify-content: space-between;

align-items: center;
${mobile({padding: "10px 0px"})}
`

const Left = styled.div`flex: 1;
display: flex;
align-items: center;`



const Language = styled.span`
font-size: 14px;
cursor: pointer;
${mobile({display: "none"})}`

const SearchContainer = styled.div`
border: 0.5px solid lightgray
display: flex;
align-items: center
margin-left: 25px;
padding: 5px;
`
const Input = styled.input`
${mobile({width: "50px"})}
`
const Center = styled.div`flex : 1;
text-align: center;
`
const Logo= styled.div`
font-weight: bold;
font-size: 45px;

${mobile({fontSize: "24px"})}
`;
const Right = styled.div`flex: 1;
display: flex;
align-items: center;
justify-content: flex-end;
${mobile({flex: 2,justifyContent: "center" })}
`
const MenuItem = styled.div`
font-size: 14px;
cursor: pointer;
margin-left: 25px;
${mobile({fontSize: "12px" , marginLeft: "10px"})}`

const Navbar = () =>{
    return (
        <Container>
            <Wrapper>
                <Left><Language>EN</Language>
                <SearchContainer>
                   <Input placeholer = "Search" />
                   <SearchOutlined style={{color: "blue", fontSize: 20, marginLeft: 5}}/>
                   
                </SearchContainer>
                </Left>
                <Center><Logo>AXON</Logo></Center>
                <Right><MenuItem>REGISTER</MenuItem>
                <MenuItem>SIGN IN</MenuItem>
                <MenuItem><Badge badgeContent={4} color="primary">
             <ShoppingCartOutlined/> </Badge></MenuItem></Right>
            </Wrapper>
            
        </Container>
    )
}
export default Navbar